import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ExcelDataset } from 'app/model/dataset/excel.dataset';
import { FormatTypeCopySource } from './format-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.excel.copySourceType,
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(ExcelDataset)] }
})
export class ExcelCopySource extends FormatTypeCopySource {
}
